<div class="mt-2"></div>

<div *ngIf="mensagemSucesso" class="alert alert-success alert-dismissible fade show" role="alert">
  <i class="fas fa-check-circle mr-2"></i>
  {{mensagemSucesso}}
  <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="mensagemSucesso = ''">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div *ngIf="mensagemErro" class="alert alert-danger alert-dismissible fade show" role="alert">
  <i class="fas fa-exclamation-triangle mr-2"></i>
  {{mensagemErro}}
  <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="mensagemErro = ''">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="card shadow mb-3">
  <div class="card-body">
    <div class="row align-items-end">
      <div class="col-md-3">
        <label class="small font-weight-bold">Data Inicial</label>
        <input type="date" class="form-control" [(ngModel)]="filtro.dataInicio" (change)="aplicarFiltros()">
      </div>
      <div class="col-md-3">
        <label class="small font-weight-bold">Data Final</label>
        <input type="date" class="form-control" [(ngModel)]="filtro.dataFim" (change)="aplicarFiltros()">
      </div>
      <div class="col-md-3">
        <label class="small font-weight-bold">Status</label>
        <select class="form-control" [(ngModel)]="filtro.status" (change)="aplicarFiltros()">
          <option [ngValue]="null">Todos os Status</option>
          <option [ngValue]="1">Nova</option>
          <option [ngValue]="2">Autorizada</option>
          <option [ngValue]="9">Duplicidade</option>
          <option [ngValue]="10">Rejeitada</option>
          <option [ngValue]="19">Denegada</option>
          <option [ngValue]="4">Cancelada</option>
        </select>
      </div>
      <div class="col-md-3">
        <button class="btn btn-outline-secondary w-100" (click)="setarDataHoje()">
          <i class="fas fa-calendar-day mr-1"></i> Hoje
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card shadow">
  <div class="card-body">
    <div *ngIf="loading" class="text-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
      <p class="mt-2 text-muted">Carregando notas fiscais...</p>
    </div>

    <div *ngIf="!loading && dataSource.length === 0" class="text-center py-5">
      <img src="/images/empty-notes.svg" alt="Sem notas" style="max-width: 180px; margin-bottom: 20px; opacity: 0.6;">
      <h3 class="text-muted">Nenhuma nota encontrada</h3>
      <p class="lead text-muted">Não existem notas fiscais emitidas para o <strong>período e filtros selecionados</strong>.</p>
      <button class="btn btn-sm btn-link" (click)="setarDataHoje()">Limpar filtros e buscar hoje</button>
    </div>

    <kendo-grid [kendoGridBinding]="filteredDataSource" *ngIf="!loading && filteredDataSource.length > 0" class="border-0">

      <kendo-grid-column title="" [width]="50">
        <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
          <span class="badge badge-pill badge-light">{{rowIndex + 1}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Número" [width]="100">
        <ng-template kendoGridCellTemplate let-nfce>
          <span class="font-weight-medium">{{nfce.numeroNFe}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Série" [width]="70">
        <ng-template kendoGridCellTemplate let-nfce>
          <span>{{nfce.serie}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Destinatário">
        <ng-template kendoGridCellTemplate let-nfce>
          <span class="text-truncate d-inline-block" style="max-width: 100%;" [title]="nfce.nomeDestinatario">
            {{nfce.nomeDestinatario}}
          </span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Data Emissão" [width]="175">
        <ng-template kendoGridCellTemplate let-nfce>
          <span><i class="far fa-calendar-alt text-muted mr-1"></i> {{nfce.dataDeEmissao | date:'dd/MM/yyyy HH:mm'}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Valor Total" [width]="130">
        <ng-template kendoGridCellTemplate let-nfce>
          <span class="font-weight-bold text-success">{{nfce.valorTotalNFe | currency:'BRL'}}</span>
        </ng-template>
        <ng-template kendoGridFooterTemplate>
          <span class="font-weight-bold text-success">Total: {{ totalGeral | currency:'BRL' }}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Status" [width]="120">
        <ng-template kendoGridCellTemplate let-nfce>
          <span class="badge badge-pill px-2 py-1" [ngClass]="{
            'badge-success': nfce.status === 2,
            'badge-warning': [1, 3, 15, 20].includes(nfce.status),
            'badge-danger': [10, 11, 14, 16, 17, 18, 19, 22, 23, 24].includes(nfce.status),
            'badge-info': [4, 5, 6, 7, 8, 9, 21].includes(nfce.status)
          }">
            <ng-container [ngSwitch]="nfce.status">
              <ng-container *ngSwitchCase="1">Nova</ng-container>
              <ng-container *ngSwitchCase="2">Autorizada</ng-container>
              <ng-container *ngSwitchCase="3">Em Processamento</ng-container>
              <ng-container *ngSwitchCase="4">Cancelada</ng-container>
              <ng-container *ngSwitchCase="5">Inutilizada</ng-container>
              <ng-container *ngSwitchCase="6">Importada</ng-container>
              <ng-container *ngSwitchCase="7">Contigenciada</ng-container>
              <ng-container *ngSwitchCase="8">De Contigência</ng-container>
              <ng-container *ngSwitchCase="9">Duplicidade</ng-container>
              <ng-container *ngSwitchCase="10">Rejeitada</ng-container>
              <ng-container *ngSwitchCase="11">Dados Inválidos</ng-container>
              <ng-container *ngSwitchCase="12">Sucesso</ng-container>
              <ng-container *ngSwitchCase="13">Falha</ng-container>
              <ng-container *ngSwitchCase="14">Conferência Rejeitou</ng-container>
              <ng-container *ngSwitchCase="15">Presa na SEFAZ</ng-container>
              <ng-container *ngSwitchCase="16">Problemas no Envio</ng-container>
              <ng-container *ngSwitchCase="17">Envio Interrompido</ng-container>
              <ng-container *ngSwitchCase="18">Problema Comunicação SEFAZ</ng-container>
              <ng-container *ngSwitchCase="19">Denegada</ng-container>
              <ng-container *ngSwitchCase="20">Recebida</ng-container>
              <ng-container *ngSwitchCase="21">Pendente de Conciliação</ng-container>
              <ng-container *ngSwitchCase="22">Rejeitada e Pendente de Conciliação</ng-container>
              <ng-container *ngSwitchCase="23">Problemas no Envio em Contingência</ng-container>
              <ng-container *ngSwitchCase="24">Problema ao Cancelar NFe</ng-container>
              <ng-container *ngSwitchDefault>{{nfce.status}}</ng-container>
            </ng-container>
          </span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Chave de Acesso" [width]="390">
        <ng-template kendoGridCellTemplate let-nfce>
          <span class="text-monospace small text-nowrap">
            {{nfce.chaveDeAcesso | chaveAcesso}}
          </span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Ações" [width]="240">
        <ng-template kendoGridCellTemplate let-nfce>
          <div class="btn-group">
            <button type="button" class="btn btn-sm btn-light mr-1" (click)="downloadXml(nfce)" kendoTooltip title="Baixar XML" *ngIf="podeDownloadXml(nfce)">
              <i class="fas fa-download text-info"></i>
            </button>
            <button type="button" class="btn btn-sm btn-light mr-1" (click)="imprimir(nfce)" kendoTooltip title="Imprimir" *ngIf="podeImprimir(nfce)">
              <i class="fas fa-print text-success"></i>
            </button>
            <button type="button" class="btn btn-sm btn-light" (click)="reenviarNota(nfce)" kendoTooltip title="Reenviar Nota" *ngIf="podeReenviar(nfce.status)" [disabled]="loading">
              <span *ngIf="loading" class="k-icon k-i-loading"></span>
              <i *ngIf="!loading" class="fas fa-paper-plane text-warning"></i>
            </button>
            <button type="button" class="btn btn-sm btn-light" (click)="cancelarNota(nfce, $event)" *ngIf="podeCancelar(nfce)" kendoTooltip title="Cancelar Nota">
              <i class="fas fa-ban text-danger"></i>
            </button>
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>

  </div>

  <div class="card-footer bg-white d-flex justify-content-between" *ngIf="!loading && filteredDataSource.length > 0">
    <div>
      <span class="text-muted">Notas exibidas: <strong>{{filteredDataSource.length}}</strong></span>
    </div>
    <button class="btn btn-outline-primary btn-sm" (click)="carregarNFCes()">
      <i class="fas fa-sync-alt mr-1"></i> Atualizar
    </button>
  </div>
</div>

<kendo-dialog title="Cancelar Nota Fiscal" *ngIf="dialogCancelamento" [minWidth]="300" [width]="500">
  <div class="p-3">
    <label class="form-label mb-2 font-weight-bold">Justificativa do cancelamento:</label>
    <textarea kendoTextArea
              [(ngModel)]="justificativaCancelamento"
              rows="5"
              style="width: 100%; min-height: 120px;"
              [disabled]="processandoCancelamento"
              placeholder="Digite a justificativa do cancelamento (mínimo 15 caracteres)">
    </textarea>
    <small class="text-muted d-block mt-1">Mínimo de 15 caracteres exigidos pela SEFAZ.</small>
  </div>
  <kendo-dialog-actions>
    <button kendoButton [disabled]="processandoCancelamento" (click)="fecharDialogCancelamento()">
      Voltar
    </button>
    <button kendoButton [disabled]="processandoCancelamento || justificativaCancelamento.length < 15" (click)="confirmarCancelamento()" [primary]="true">
      <span *ngIf="processandoCancelamento" class="k-icon k-i-loading"></span>
      Confirmar Cancelamento
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
